export function buffer2Blob(buffer: ArrayBuffer, type = 'text/plain'): string {
  return URL.createObjectURL(new Blob([buffer], { type }))
}
